import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { FatcaTypeEntity } from '../../../../../core';

@JsonConverter
export class FatcaTypeEntityAdapter implements JsonCustomConvert<FatcaTypeEntity | undefined> {
    serialize(type: FatcaTypeEntity): any | undefined {
        return type ? String(type) : undefined;
    }

    deserialize(type: any): FatcaTypeEntity | undefined {
        switch (type) {
            case '1F':
                return FatcaTypeEntity.A1;
            case '2F':
                return FatcaTypeEntity.A2;
            case '3F':
                return FatcaTypeEntity.B;
            case '4F':
                return FatcaTypeEntity.C;
            case '5F':
                return FatcaTypeEntity.D;
            case '6F':
                return FatcaTypeEntity.E;
            case '8F':
                return FatcaTypeEntity.F;
            case '9F':
                return FatcaTypeEntity.G;
            default:
                return undefined;
        }
    }
}
